export default {
  title: 'Contacter Nextories',
  creation: {
    addLabel: 'Envoyer ma demande',
    sendMessage: 'Envoyer',
    addImage: 'Ajouter des images',
    contactSent: 'Une demande a été envoyée le {date}, vous recevrez une réponse par email dans les meilleurs délais.',
    contactJustSent: 'Une demande a été envoyée, vous recevrez une réponse par email dans les meilleurs délais.',
    title: 'Envoyer une demande de contact',
    form: {
      message: 'Votre message',
      messageWarning: 'Un message est nécessaire.',
      fileUpload: 'Ajouter un fichier',
      max: '(12 Mo maximum)',
      select: 'Quel est l\'objet de votre demande ?',
      type: {
        placeholder: 'Sélectionnez une raison',
        help: 'Demande d\'informations',
        disputes: 'Déclarer un litige',
      },
    },
  },
  list: {
    date: 'Date',
    type: 'Type',
    message: 'Message',
    empty: 'Vous n\'avez pas encore fait de demande de contact.',
    previous: 'Vos demandes de contact',
  },
};
